(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Transfer", [], factory);
	else if(typeof exports === 'object')
		exports["Transfer"] = factory();
	else
		root["Transfer"] = factory();
})(this, function() {
return 